import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/gateway';
import { MetricsFactory, MetricsOverview } from '../models';

@Injectable({ providedIn: 'root' })
export class MetricsService {
  private readonly apiService = inject(ApiService);

  public async getMetrics(): Promise<MetricsOverview> {
    try {
      const path: string = `${MetricsFactory.getPath()}/overview`;
      const metrics: MetricsOverview = await this.apiService.get<MetricsOverview>({ path });
      return metrics;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
